const URL_BASE=process.env.REACT_APP_API;

export const URL_STATS_LIST=`${URL_BASE}/hotmers/stat`;